import { i18n, Messages } from '@lingui/core';

const initI18n = (locale: string, messages: Messages): void => {
  i18n.load(locale, messages);
  i18n.activate(locale);
};

export default initI18n;
